import React, { useState } from 'react';
import Select from 'react-select'
import { FormGroup, Label, Button, Col, FormText, Input, Row, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import AddNewArtistModal from "./AddNewArtistModal";
import './row.css';
import { getCookie } from "../../jwt/_helpers/cookie";
import { Trans, useTranslation } from 'react-i18next';

const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const arrowStyleWrap = {
  display: 'flex'
}
const arrowStyle = {
  padding: 3,
  cursor: 'pointer'
}

const openInNewTab = url => {
  window.open(url, '_blank', 'noopener,noreferrer');
};

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

const RowSelect = ({ values }) => {
  const tokenAPI = getCookie("token");
  const { t } = useTranslation();

  const [featuringModal, featuringModalSET] = useState(false);
  const [featuringModalData, featuringModalDataSET] = useState(false);
  const [artistTypeFieldTouched, artistTypeFieldTouchedSET] = useState(false);

  const options = {
    'method': 'GET',
    mode: 'cors',
    headers: {
      Authorization: `Bearer ${tokenAPI}`,
      "x-api-key": X_API_KEY,
      'Content-Type': 'application/json'
    }
  }

  const artistType = [
    { value: 'main', label: t('releases.transfer_artists_row.option.artistType.main') },
    { value: 'featuring', label: t('releases.transfer_artists_row.option.artistType.featuring') },
  ]
  const artistTypeUpdate = [
    { value: 'main', label: t('releases.transfer_artists_row.option.artistType.main'), isDisabled: false },
    { value: 'featuring', label: t('releases.transfer_artists_row.option.artistType.featuring'), isDisabled: false },
    { value: 'remixer', label: t('releases.transfer_artists_row.option.artistType.remixer'), isDisabled: false },
  ]
  
  const artistTypeUpdateDisabled = [
    { value: 'main', label: t('releases.transfer_artists_row.option.artistType.main'), isDisabled: false },
    { value: 'featuring', label: t('releases.transfer_artists_row.option.artistType.featuring'), isDisabled: false },
    { value: 'remixer', label: t('releases.transfer_artists_row.option.artistType.remixer'), isDisabled: true },
  ]
  
  const artistTypeFeaturingOnly = [
    { value: 'main', label: t('releases.transfer_artists_row.option.artistType.main'), isDisabled: true },
    { value: 'featuring', label: t('releases.transfer_artists_row.option.artistType.featuring') },
  ]

  const { artist, removeArtist, index, manageArtistData, trackOrderChange,listOfArtists, listOfArtistsSET, editTracks, remix, blockedValeues, subUserEndpoint, parentUserOnly, mainArtistsCount, disabledAtCount, revalidateField } = values;
  const key = artist.key;

  const borderColor = artistTypeFieldTouched
  ? (artist.type ? "#2dce89" : "#f62d51") 
  : "#e9ecef";

  return (
    <>
    <div className="artistWrap" style={{flexDirection: "column"}}> 
      <div className="artistWrap" style={{margin: "0"}}>
        <Col xs="1" style={arrowStyleWrap}>
          <div style={arrowStyle} onClick={() => trackOrderChange('up', key, index, artist.order, listOfArtists, listOfArtistsSET)}>▲</div>
          <div style={arrowStyle} onClick={() => trackOrderChange('down', key, index, artist.order, listOfArtists, listOfArtistsSET)}>▼</div>
        </Col>
        <Col xs="3">
           <div className="releaseFileRow">
              <p className="releaseFileRowName">{artist.name}</p>
           </div>          
        </Col>
        <Col xs="3">
          <Select
            id={`artist[${index}].type`}
            name={`artist[${index}].type`}
            value={artist.type}
            components={{ IndicatorSeparator:() => null }}
            options={editTracks ? (remix ? artistTypeUpdate : artistTypeUpdateDisabled) : (mainArtistsCount < disabledAtCount ? artistType : artistTypeFeaturingOnly)}
            onChange={(e) => {
              if (editTracks && e.value === 'featuring') {
                featuringModalSET(true);
                featuringModalDataSET({index: index, type: 'type', obj: e});
                return;
              }
              if (blockedValeues !== null && blockedValeues.blockedSubmit){
                blockedValeues.setBlockedSubmit(false);
              }
              manageArtistData(index, 'type', e)
              revalidateField(`artist[${index}].type`)
              revalidateField("atleastOneMainArtist")
            }}
            onFocus={() => {
              artistTypeFieldTouchedSET(true)
              revalidateField(`artist[${index}].type`)
            }}
            onMouseEnter={() => {
              artistTypeFieldTouchedSET(true)
              revalidateField(`artist[${index}].type`)
            }}
            styles={{
              menu: styles => ({ ...styles, zIndex: 10 }),
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: artistTypeFieldTouched ? borderColor : baseStyles.borderColor,
                boxShadow: state.isFocused || state.isHovered 
                  ? (artist.type ? "0 0 0 0.2rem rgba(45, 206, 137, 0.25)" : "0 0 0 0.2rem rgba(246, 45, 81, 0.25)") 
                  : "0 0 0 1px #e9ecef",
                borderRadius: "2px",
              }),
            }}
            className="artistType"
          />
        </Col>
        <Col xs="2">
          {/* <Button color={'danger'} disabled onClick={() => {
            removeArtist(index);
            if (blockedValeues !== null && blockedValeues.blockedSubmit){
              blockedValeues.setBlockedSubmit(false);
            }
          }}>Remove </Button> */}
        </Col>
      </div>
      <div style={{width: '100%', display: 'flex'}}>
        <Col xs="1"></Col>
        <Col xs="3">
          <div className="fv-help-block" style={{ display: 'none'}} id={"err_name_" + key}>{t('releases.transfer_artists_row.message.errorArtistRequired')}</div>
        </Col>
        <Col xs="3">
          <div className="fv-help-block" style={{ display: 'none'}} id={"err_type_" + key}>{t('releases.transfer_artists_row.message.errorArtistTypeRequired')}</div>
        </Col>
      </div>
    </div>
    <Modal isOpen={featuringModal} centered={true}>
        <ModalHeader>{t('releases.transfer_artists_row.modal.header')}</ModalHeader>
        <ModalBody>{t('releases.transfer_artists_row.modal.body')}</ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => featuringModalSET(false)}>
            {t('releases.transfer_artists_row.modal.button.cancel')}
          </Button>
          <Button color="success" onClick={() => {
            manageArtistData(featuringModalData.index, featuringModalData.type, featuringModalData.obj);
            featuringModalSET(false);
          }}>
            {t('releases.transfer_artists_row.modal.button.confirm')}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

const RowLabel = () => {
  const { t } = useTranslation();
  return (
    <Row className="artistWrap labelRow">
      <Col xs="1">
        {t('releases.transfer_artists_row.label.order')}
      </Col>
      <Col xs="3">
        {t('releases.transfer_artists_row.label.artistName')}
      </Col>
      <Col xs="3">
        {t('releases.transfer_artists_row.label.artistType')}
      </Col>
      <Col xs="2">
      </Col>
      <Col xs="1">
      </Col>
      <Col xs="1">
      </Col>
    </Row>
  )
}

const RowSelectDisabled = ({ data, name }) => {
  const { t } = useTranslation();
  let type;
  if (data.kind === 'main') {
    type = t('releases.transfer_artists_row.option.artistType.main');
  } else if (data.kind === 'featuring') {
    type = t('releases.transfer_artists_row.option.artistType.featuring');
  } else {
    type = data.kind;
  }
  return (
    <div className="artistWrap" style={{flexDirection: "column"}}> 
      <div className="artistWrap" style={{margin: "0"}}>
        <Col xs="1" style={arrowStyleWrap}>
          <div style={arrowStyle}>▲</div>
          <div style={arrowStyle}>▼</div>
        </Col>
        <Col xs="2">
          <Input
            type="text"
            value={name ? name : ''}
            onChange={(e) => false}
            disabled={true}
          />
          
        </Col>
        <Col xs="2">
        <Input
            type="text"
            value={type}
            onChange={(e) => false}
            disabled={true}
          />
        </Col>
        <Col xs="2">
          <Button color={'danger'} disabled={true}>{t('releases.transfer_artists_row.button.remove')}</Button>
        </Col>
      </div>
    </div>
  )
}

const TransferArtistRow = ({ values, disabled = false, dataView = null, disabledAtCount = 4, editTracks = false, blockedValeues = null }) => {
  const { setNewArtist, listOfArtists, removeArtist, addNewArtist, manageArtistData, trackOrderChange, listOfArtistsSET, remix = false, subUserId, subUserEndpoint, parentUserOnly, revalidateField } = values;
  
  let mainArtistsCount = listOfArtists.filter(artist => artist.type && artist.type.value === "main").length;
  
  const [modal, setModal] = useState(false);

  const { t } = useTranslation();

  return (
    <>
      <FormGroup>
        <Label>{t('releases.transfer_artists_row.label.artists')}</Label>
        <Row>
          <RowLabel />
        </Row>
        <Row>
          {
            !disabled ? listOfArtists.map((artist, index) => {
              const itemVal = { index, artist, removeArtist, manageArtistData, trackOrderChange, listOfArtists, listOfArtistsSET, editTracks, remix, blockedValeues, subUserEndpoint, parentUserOnly, mainArtistsCount, disabledAtCount, revalidateField }
              return (
                <RowSelect values={itemVal} key={artist.key} />
              );
            })
            :
            dataView.map(artist => {
              
              return <RowSelectDisabled  data={artist} name={artist.artist.name} key={artist.id + artist.artist + artist.kind} />
            })
          }

        </Row>
        <Row style={{width: '100%', display: 'flex'}}>
          <FormGroup>
            <input className="hiddenInput" type="text" id="atleastOneMainArtist" name="atleastOneMainArtist" value={mainArtistsCount>0? "yes": ""} readOnly/>
          </FormGroup>
        </Row>
        {
          disabledAtCount === 4 && 
          <FormText color="muted">
            <Trans i18nKey="releases.transfer_artists_row.help_text.artists">
              If the release is written by more than <strong>4 Main Artists</strong> please use <strong>Various Artists</strong>. Track artists, remixers and contributors should be added in Track Edit step.
            </Trans>
          </FormText>
        }
        {/* {
          !disabled && (
            <div>
            <Button disabled={true} color="primary" onClick={() => addNewArtist([...listOfArtists, { name: "", type: "", order: listOfArtists.length + 1, key: key }])}>Add another</Button>{' '}
            <Button color="success" disabled={true} onClick={() => openInNewTab("/artists") }>Create new?</Button>
          </div>
          )
        } */}
       
      </FormGroup>
      {modal && <AddNewArtistModal toggleModal={setModal} modal={modal} setNewArtist={setNewArtist} subUserId={subUserId} subUserEndpoint={subUserEndpoint} parentUserOnly={parentUserOnly} />}
    </>
  );
};

export default TransferArtistRow;